import { render, staticRenderFns } from "./MDTCreatePage.vue?vue&type=template&id=349d8b23&scoped=true"
import script from "./MDTCreatePage.vue?vue&type=script&lang=js"
export * from "./MDTCreatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349d8b23",
  null
  
)

export default component.exports